<div class="grid-container">
    <div class="grid-item upload left">
        <div class="content">
            <mat-card class="card">
                <mat-card-content class="drag-and-drop">
                    <div>
                        <p class="title">Upload CSV file</p>
                    </div>
                    <div class="drag-and-drop">
                        <mat-icon aria-hidden="false" fontIcon="cloud_upload" class="cloud-upload"></mat-icon>
                        <p class="drag-and-drop">Drag & Drop files here</p>
                        <p class="or">OR</p>
                        <div class="button browse-files">
                            <p class="browse-files">Browse files</p>
                        </div>
                    </div>
                    <div class="button load-dataset disabled">
                        <p class="load-dataset">Load Dataset</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="grid-item daterange left">
        <div class="content">
            <mat-card class="card">
                <mat-card-content class="daterange">
                    <div>
                        <p class="title">Import from date range</p>
                    </div>
                    <div class="input">
                        <input type="datetime-local" class="start-date" />
                        <input type="datetime-local" class="end-date" />
                    </div>
                    <div class="button load-dataset disabled">
                        <p class="load-dataset">Load Dataset</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="grid-item sql left">
        <div class="content">
            <mat-card class="card">
                <mat-card-content class="sql">
                    <div>
                        <p class="title">Import from SQL</p>
                    </div>
                    <div>
                        <textarea matInput class="sql"></textarea>
                    </div>
                    <div class="button load-dataset disabled">
                        <p class="load-dataset">Load Dataset</p>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="grid-item latest right">
        <div class="content">
            <mat-card class="card">
                <mat-card-content class="latest">
                    <div class="title">
                        <p class="title">Latest Datasets</p>
                        <div class="button load-dataset disabled">
                            <p class="load-dataset">Load Dataset</p>
                        </div>
                    </div>
                    <div class="search">
                        <input matInput type="search" class="search">
                        <mat-icon aria-hidden="false" fontIcon="search" class="search"></mat-icon>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>